import { Link } from "react-router-dom";
import { Box, Divider, Heading, List, ListItem, Text } from "@chakra-ui/react";
import { Extraction } from "../../../api/types";
import { typedSxMap } from "../../../utils/typedSxMap";
import { formatFileSize } from "./utils/formatFileSize";
import OverviewTimeline from "./OverviewTimeline";

const styles = typedSxMap({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "var(--m-xl)",
  },
  firstBox: {
    marginTop: "-20px", // sorry :)
  },
  sectionHeading: {
    fontSize: "var(--font-size-xl)",
    color: "var(--color-text-strong)",
  },
  divider: {
    borderColor: "var(--color-border)",
    opacity: 1,
    borderBottomWidth: "1px",
  },
  summary: {
    display: "flex",
    margin: "var(--m-xxs) 0 ",
    gap: "var(--m)",
  },
  summaryItem: {
    boxShadow: "inset -1px 0 var(--color-text-soft)",
    paddingRight: "var(--m-xxl)",
    display: "flex",
    flexDirection: "column",
    gap: "var(--m-xxs)",
    "&:last-of-type": {
      boxShadow: "none",
    },
    "& > p": {
      marginBottom: 0,
      "&:first-of-type": {
        color: "var(--color-text-soft)",
      },
    },
  },
  summaryItemValue: {
    fontSize: "var(--font-size-xl)",
    fontWeight: "var(--external-fontWeights-normal)",
    color: "var(--color-text-strong)",
  },
  details: {
    display: "flex",
    flexDirection: "column",
    gap: "var(--m-xxxs)",
  },
  detailsItem: {
    display: "flex",
    justifyContent: "",
    color: "var(--color-text-strong)",

    "& > span": {
      textAlign: "left",
      "&:first-of-type": {
        maxWidth: "350px",
        color: "var(--color-text-soft)",
        width: "50%",
      },
    },
  },
});

type OverviewSectionProps = {
  extraction: Extraction;
};

export default function OverviewSection({ extraction }: OverviewSectionProps) {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.firstBox}></Box>
      {(extraction.status === "completed" || extraction.status === "importing") && (
        <Box>
          <Heading as="h3" sx={styles.sectionHeading}>
            Rows Imported
          </Heading>
          <Divider sx={styles.divider} />
          <Box sx={styles.summary}>
            <Box sx={styles.summaryItem}>
              <Text>Accepted</Text>
              <Text sx={styles.summaryItemValue}>{0}</Text>
            </Box>
            <Box sx={styles.summaryItem}>
              <Text>Errors</Text>
              <Text sx={styles.summaryItemValue}>{0}</Text>
            </Box>
            <Box sx={styles.summaryItem}>
              <Text> Pending</Text>
              <Text sx={styles.summaryItemValue}>{0}</Text>
            </Box>
          </Box>
        </Box>
      )}

      <Box>
        <Heading as="h3" sx={styles.sectionHeading}>
          Details
        </Heading>
        <Divider sx={styles.divider} />
        <List sx={styles.details}>
          <ListItem sx={styles.detailsItem}>
            <span>Schema</span>
            <Link to={`/importsrschemas/${extraction.schema?.id}`}>
              <span>{extraction.schema?.name}</span>
            </Link>
          </ListItem>
          <ListItem sx={styles.detailsItem}>
            <span>File name</span>
            <span>{extraction.file_name}</span>
          </ListItem>
          <ListItem sx={styles.detailsItem}>
            <span>File size</span>
            <span>{formatFileSize(extraction.file_size)}</span>
          </ListItem>
        </List>
      </Box>

      <Box>
        <Heading as="h3" sx={styles.sectionHeading}>
          Timeline
        </Heading>
        <Divider sx={styles.divider} />
        <OverviewTimeline timelineData={extraction.status_history} />
      </Box>
    </Box>
  );
}
